import React from 'react';

const ListIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.5 10.0003L7.5 10.0003M17.5 5.00033L7.5 5.00033M17.5 15.0003L7.5 15.0003M4.16667 10.0003C4.16667 10.4606 3.79357 10.8337 3.33333 10.8337C2.8731 10.8337 2.5 10.4606 2.5 10.0003C2.5 9.54009 2.8731 9.16699 3.33333 9.16699C3.79357 9.16699 4.16667 9.54009 4.16667 10.0003ZM4.16667 5.00033C4.16667 5.46056 3.79357 5.83366 3.33333 5.83366C2.8731 5.83366 2.5 5.46056 2.5 5.00033C2.5 4.54009 2.8731 4.16699 3.33333 4.16699C3.79357 4.16699 4.16667 4.54009 4.16667 5.00033ZM4.16667 15.0003C4.16667 15.4606 3.79357 15.8337 3.33333 15.8337C2.8731 15.8337 2.5 15.4606 2.5 15.0003C2.5 14.5401 2.8731 14.167 3.33333 14.167C3.79357 14.167 4.16667 14.5401 4.16667 15.0003Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ListIcon;
